import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { RRSpinnerModel } from '../../../spinner/public-api';
import { RRIMediaFile } from '../../interfaces/media-file.interface';

@Component({
  selector: 'rr-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.scss'],
})
export class MediaViewerComponent implements OnChanges {
  public readonly IMAGE_PLACEHOLDER =
    '../../../../assets/images/placeholder.jpg';

  public mediaHasError: boolean;
  public spinnerStatus: RRSpinnerModel;
  public isVideo: boolean;
  public isImage: boolean;

  @Input() file: RRIMediaFile;

  constructor() {
    this.spinnerStatus = {
      show: true,
      text: 'Loading',
    };
    this.mediaHasError = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['file'] &&
      changes['file'].currentValue &&
      changes['file'].currentValue.mimeType
    ) {
      this.isVideo = changes['file'].currentValue.mimeType.includes('video');
      this.isImage = changes['file'].currentValue.mimeType.includes('image');
    } else {
      this.mediaHasError = true;
      this.spinnerStatus.show = false;
    }
  }

  public onMediaHasLoaded(): void {
    this.spinnerStatus.show = false;
  }

  public onMediaHasError(): void {
    this.mediaHasError = true;
    this.spinnerStatus.show = false;
  }

  public getMediaSource(): string {
    if (this.file && this.file.downloadUrl) {
      this.mediaHasError = false;
      this.spinnerStatus.show = false;
      return this.file.downloadUrl;
    }

    this.mediaHasError = true;
    return '';
  }
}
